import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1a1a1a',
    },
    background: {
      default: '#ffffff',
      paper: '#f8f8f8',
    },
    text: {
      primary: '#1a1a1a',
      secondary: '#444',
    },
  },
  typography: {
    fontFamily: '"Crimson Pro", Georgia, serif',
    h1: { fontFamily: '"Crimson Pro", Georgia, serif' },
    h2: { fontFamily: '"Crimson Pro", Georgia, serif' },
    h3: { fontFamily: '"Crimson Pro", Georgia, serif' },
    h4: { fontFamily: '"Crimson Pro", Georgia, serif' },
    h5: { fontFamily: '"Crimson Pro", Georgia, serif' },
    h6: { fontFamily: '"Crimson Pro", Georgia, serif' },
    body1: { fontFamily: '"Crimson Pro", Georgia, serif' },
    body2: { fontFamily: '"Crimson Pro", Georgia, serif' },
    subtitle1: { fontFamily: '"Crimson Pro", Georgia, serif' },
    subtitle2: { fontFamily: '"Crimson Pro", Georgia, serif' },
    caption: { fontFamily: '"Crimson Pro", Georgia, serif' },
    button: { fontFamily: '"Crimson Pro", Georgia, serif' },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiLink: {
      styleOverrides: {
        root: {
          '&:hover': {
            textDecoration: 'underline',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          transition: 'background-color 0.2s ease',
        },
      },
    },
  },
});

export default theme;
